module.exports = __webpack_public_path__ + "img/jf_home_15.8434dec9.jpg";